export const messages = {
  en: {
    pay: {
      title: 'Payment',
      receiverInfo: 'Receiver Information',
      productInfo: 'Product Information',
      settlementInfo: 'Settlement Information',
      cart: 'Shopping Cart',
      confirmOrder: 'Confirm Order',
      payment: 'Payment',
      paymentSuccess: 'Payment Success',
      useWechatScan: 'Use WeChat Scan to Pay',
      contactAdmin: 'You can also contact the administrator to transfer',
      totalItems: 'items in total',
      freight: 'Freight',
      incorrectOrder: 'Incorrect order number, please use correctly',
      scanToPay: 'Please scan the QR code with WeChat to pay'
    }
  },
  zh: {
    pay: {
      title: '支付',
      receiverInfo: '收货人信息',
      productInfo: '商品信息',
      settlementInfo: '结算信息',
      cart: '购物车',
      confirmOrder: '确认订单',
      payment: '付款',
      paymentSuccess: '支付成功',
      useWechatScan: '使用微信扫码支付',
      contactAdmin: '也可以联系管理员转账',
      totalItems: '件商品',
      freight: '运费',
      incorrectOrder: '订单号不正确，请正确使用',
      scanToPay: '请使用微信扫描二维码支付'
    }
  }
}